<template>
  <section class="relative overflow-hidden">
    <div
      class="absolute inset-0 bg-gradient-to-b from-primary/10 to-transparent dark:from-primary/5"
    />

    <div class="container relative py-16 px-4 mx-auto">
      <!-- Header -->
      <div class="text-center max-w-3xl mx-auto mb-12">
        <h2
          class="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-3"
        >
          Upcoming Events
          <Icon
            name="heroicons:sparkles"
            class="inline-block w-6 h-6 text-yellow-400 animate-pulse"
          />
        </h2>
        <p class="text-gray-600 dark:text-gray-300">
          Stay updated with the newest academic opportunities
        </p>
      </div>

      <!-- Skeleton Loading -->
      <EventsSkeletonLoader
        v-if="pending"
        class="grid sm:grid-cols-2 gap-6"
        :count="4"
      />

      <!-- Events Grid -->
      <div v-else-if="events?.data?.length" class="grid sm:grid-cols-2 gap-6">
        <EventsCard
          v-for="event in events.data"
          :key="event.id"
          :event="event"
        />
      </div>

      <!-- Empty State -->
      <div v-else class="text-center py-12">
        <p class="text-gray-500 dark:text-gray-400">No upcoming events found</p>
      </div>

      <!-- Action Button -->
      <div class="text-center mt-12">
        <UButton to="/events" text="Browse All Events"> </UButton>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
interface Event {
  id: number;
  attributes: {
    // Add your event type definition here
  };
}

interface EventsResponse {
  data: Event[];
}

// Use composable for data fetching
const { data: events, pending } = await useAsyncData<EventsResponse>(
  "latest-events",
  () =>
    $fetch("https://backend.postfeed.in/api/aa-events", {
      params: {
        populate: ["aa_category", "aa_tags",'aa_events_type','cover'],
        "filters[starts][$gt]": new Date().toISOString(),
        sort: "starts:asc",
        "pagination[page]": 1,
        "pagination[pageSize]": 10,
      },
    }),
  {
    transform: (response) => response,
    watch: false,
    server: true,
    lazy: true,
  }
);
</script>

<style scoped>
.container {
  max-width: 1200px;
}
</style>
